<template>
  <div class="container">
    <div class="info" v-if="info.id">
      <el-descriptions title="需求信息">
        <el-descriptions-item label="标题">{{
          info.title
        }}</el-descriptions-item>
        <el-descriptions-item label="类型">
          {{ getNameByValue(demandTypes, info.type) }}
        </el-descriptions-item>
        <el-descriptions-item label="类目">{{
          info.categories
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          {{ getNameByValue(demandStatus, info.status) }}
          <el-button
            @click="updateStatus(5)"
            type="success"
            v-if="info.status === 2"
            >审核上架</el-button
          >
          <el-button
            @click="updateStatus(4)"
            type="danger"
            v-if="info.status === 2"
            >审核拒绝</el-button
          >
        </el-descriptions-item>
        <el-descriptions-item label="城市">{{
          info.city || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{
          info.end_time || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="招生进度"
          >已招{{ info.total_leads }}/目标{{
            info.target_user_count
          }}</el-descriptions-item
        >
        <el-descriptions-item label="佣金">{{
          info.prepay_amount || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="图片">
          <div v-if="info.imgs">
            <el-image
              v-for="(pic, index) in info.imgs.split(',')"
              style="width: 150px; height: 150px"
              :src="pic"
              fit="cover"
              :preview-src-list="info.imgs.split(',')"
              :key="index"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <el-descriptions title="门店信息">
        <el-descriptions-item label="发布门店">{{
          info.mec_name
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-if="edit">
         <el-input v-model="title" autosize type="textarea" placeholder="标题" />
      <el-input v-model="desc" autosize type="textarea" placeholder="内容" />
    </div>
    <div v-else>
      <el-descriptions title="需求信息">
        <template #extra>
          <el-button type="primary" @click="edit = true">修改</el-button>
        </template>
      </el-descriptions>
      <div style="white-space: pre-wrap">
        {{ info.description || "" }}
      </div>
    </div>

    <div class="m-t20">
      <el-descriptions title="课程"> </el-descriptions>
      <div class="flex card" v-for="(v, i) in info.courses" :key="i">
        <img :src="v.face_url" class="avatar" />
        <div class="info flex-col jc-e">
          <div>{{ v.course_name }}</div>
          <div>{{ v.price }}元 {{ v.course_num }}节</div>
          <div>佣金：{{ v.per_user_commission }}</div>
        </div>
      </div>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="招生学员" name="stu"> 
        <studentList ref="stu"></studentList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import { demandTypes, demandStatus } from "../dict.js";
import { getNameByValue } from "@/utils/utils.js";
import studentList from '../components/studentList/studentList.vue';
export default {
  components:{
    studentList
  },
  data() {
    return {
      demandStatus,
      demandTypes,
      id: "",
      info: {},
      activeName: "stu",
      manager: JSON.parse(localStorage.getItem("managerInfo")),
      edit: false,
      title: "",
      desc: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
    this.$nextTick(() => {
     this.$refs.stu.init()
    });
  },

  methods: {
    updateStatus(status) {
        let data = {
          id: this.id,
          status,
        };
        if (status === 5) {
          data.title = this.info.title == this.title ? null : this.title;
          data.description = this.info.description == this.desc ? null : this.desc;
        }

      this.$post("/user/enrollDemands/update", data).then((res) => {
        this.$message("成功");
        this.info.status = status;
      });
    },
    handleClick(tab) {
      this.$refs[tab.name].init();
    },
    getDetails() {
      this.$axios({
        url: "/user/enrollDemands/getInfo",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.info = res.data.data;
        this.title = res.data.data.title;
        this.desc = res.data.data.description;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}

.card {
  width: fit-content;
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: 10px;
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .info {
    margin-left: 10px;
    font-size: 14px;
  }
}
.pic {
  width: 70px;
  height: 70px;
}
</style>